import { IDate } from 'interfaces/date';
import React from 'react';
import ReactDatePicker from 'react-datepicker';
import { DATE_FORMATS } from 'utils';

const DatePicker = (props: IDate.IDatePickerProps) => {
  const {
    date,
    onChange,
    showMonthDropdown = false,
  } = props;
  
  return (
    <ReactDatePicker
      className={'form-control'}
      selected={new Date(date)}
      // @ts-ignore
      onChange={date => onChange(moment(date).format(DATE_FORMATS.MM_DD_YYYY))}
      showMonthDropdown={showMonthDropdown}
    />
  );
};

export default DatePicker;